<template>
  <nd-dialog
    v-model="visible"
    close-btn
    :footer="false"
  >
    <template #custom>
      <div class="dialog-content">
        <div class="dialog-main" :style="{backgroundImage: `url(${img})`}" @click="toWithdraw">
          <div v-if="showValue" class="main-value">{{showValue}}天</div>
        </div>
        <div class="dialog-footer">
          <div class="footer-btn" @click="visible = false">放弃使用</div>
        </div>
      </div>
    </template>
  </nd-dialog>
</template>

<script>
export default {
  name: 'YzdDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    img: {
      type: String,
      default: ''
    },
    showValue: {
      type: Number,
      default: null
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    // 去提现
    toWithdraw () {
      this.visible = false
      this.$router.push('/withdraw/index')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.dialog-content{
  .dialog-main{
    width: 623px;
    height: 693px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    .main-value{
      font-size: 86px;
      color: #F13C24;
      font-weight: 600;
      text-align: center;
      padding-top: 424px;
    }
  }
  .dialog-footer{
    margin-top: 29px;
    text-align: center;
    .footer-btn{
      color: #fff;
      text-decoration: underline;
    }
  }
}
</style>